import { createSlice } from '@reduxjs/toolkit';

const sliceFlags = createSlice({
  name: 'flagsNames',
  initialState: {
    flagFormAdd: false,
    flagFormUpdate: false,
    isSavedTask: true,
    isDrag: false,
    totalPoint: 0,
  },
  reducers: {
    setFlagNameAddForm(state, action) {
      state.flagFormAdd = action.payload;
    },
    setFlagNameUpdateForm(state, action) {
      state.flagFormUpdate = action.payload;
    },

    setSavedTask(state, action) {
      state.isSavedTask = action.payload;
    },

    setTotalPoint(state, action) {
      state.totalPoint = action.payload;
    },
  },
});

export const { setFlagNameAddForm, setFlagNameUpdateForm, setSavedTask, setTotalPoint } = sliceFlags.actions;

export const getFlagFormAdd = state => state.flagsNames.flagFormAdd;
export const getFlagFormUpdate = state => state.flagsNames.flagFormUpdate;
export const getIsSavedTask = state => state.flagsNames.isSavedTask;
export const getTotalPoint = state => state.flagsNames.totalPoint;

export default sliceFlags.reducer;
